<template>
  <div id="wx_bind_outer" class="container" >
    <div>
      <div>
        <span style="font-size: 1.5rem;">尊敬的用户，欢迎您使用微信登录上海市篮球协会官网！</span>

        <div style="max-width: 600px;">
          <div style="margin-top: 30px;">绑定已有账号</div>

          <div style="margin-top: 30px" v-if="userData != null">
            <el-image fit="cover" :src="userData.wxUserInfoModel.headimgurl" style="width: 120px;height: 120px;border-radius: 2px;border: solid 1px #eeeeee;"></el-image>
          </div>

          <div style="margin-top: 20px;">
            <el-input v-model="userName" placeholder="请输入账户名称"
                      @focus="nameInputBeginEdit"
                      @blur="nameInputBlur" clearable></el-input>
            <div style="height: 30px;padding-left: 15px;text-align: left;">
              <span v-if="userNotice != null" style="font-size: 0.8rem;color: #fc1a34;">{{userNotice}}</span>
            </div>
          </div>

          <div >
            <el-input v-model="pwd" placeholder="请输入登录密码" type="password" clearable></el-input>
          </div>

          <div style="margin-top: 30px;">
            <el-input v-model="mobile" placeholder="请输入手机号" clearable></el-input>
          </div>

          <div id="phone_input" style="width: 100%;display: flex;flex-direction: row;flex-wrap: nowrap;margin-top: 30px;">
            <el-input v-model="verifyCode" placeholder="请输入验证吗" clearable></el-input>
            <!--          <el-button style="margin-left: 5%;color: white;background-color: #fc1a34;border: none;" round>获取验证码</el-button>-->
            <el-button v-if="timeValue == 0"
                       @click="codeButtonClicked"
                       round>获取验证码</el-button>
            <el-button v-else round disabled>{{timeValue}}s重新获取</el-button>
          </div>

          <div style="margin-top: 40px;">
            <el-button
              @click="bindButtonClicked"
              style="color: white;background-color: #fc1a34;border: none;width: 40%;min-width: 150px;" round>绑定</el-button>
            <a href="javascript:void(null);"
               @click="skipButtonClicked"
               style="margin-left: 15px;">跳过</a>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeixinLoginBind",
  data() {
    return {
      code: null,
      mobile: '',
      userName: '',
      pwd: '',
      verifyCode: '',
      userData: null,
      timerFlag: null,
      timeValue: 0,
      requestLoading: false,
      userNotice: null,
    }
  },
  computed: {
    httpManager() {
      return this.$store.state.http;
    },
    dataManager() {
      return this.$store.state.dataStore;
    }
  },

  mounted() {
    let weixinData = this.dataManager.getWeixinData();
    if (weixinData != null) {
      this.userData = weixinData;
    } else {
      let newLocation = this.$router.resolve({
        name: 'loginPage',

      });
      window.location.href = newLocation.href;
    }
  },
  methods: {
    nameInputBeginEdit() {
      this.userNotice = null;
    },
    nameInputBlur() {
      let userName = this.userName.removeBlanks();
      if (userName == '') {
        return;
      }
      let _this = this;
      this.httpManager.ajax.userExist(userName,function (data) {
        let code = data.code;
        if (code == 0) {
          let successCode = data.data;
          if (successCode <= 0) {
            _this.userNotice = '该账号不存在';
          }
        }
      }, function (data) {
      });

    },

    getUserData() {
      let params = {
        code: this.code
      };
      let _this = this;
      this.httpManager.ajax.userQrconnect(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.userData = data.data;
          return;
        }

        _this.$toast('数据加载失败');
      }, function (data) {
        _this.$toast('数据加载失败，请刷新');
      })
    },
    codeButtonClicked() {
      if (this.requestLoading) {
        return;
      }
      if (this.timeValue != 0) {
        return;
      }
      let mobile = this.mobile;
      if (mobile == null) {
        mobile = '';
      }
      mobile = mobile.removeBlanks();
      if (mobile == '') {
        this.$toast('请输入手机号！');
        return;
      }

      if (!mobile.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let params = {
        phoneNumbers: mobile,
        tag: 'reg'
      }
      let _this = this;
      this.requestLoading = true;
      this.httpManager.ajax.smsSend(params, function (data) {
        _this.requestLoading = false;
        if (data.code == 0) {
          _this.timeValue = 60;
          _this.timerFlag = setInterval(_this.codeSecondOperate, 1000);
          return;
        }
        _this.$toast('发送失败！');
      }, function (data) {
        _this.requestLoading = false;
        _this.$toast('发送失败，请重试！');
      });
    },
    codeSecondOperate() {
      this.timeValue --;
      if (this.timeValue <= 0) {
        this.clearTimeFlag();
      }
    },
    clearTimeFlag() {
      if (this.timerFlag != null) {
        clearInterval(this.timerFlag);
        this.timerFlag = null;
        this.timeValue = 0;
      }
    },

    bindButtonClicked() {
      if (this.requestLoading) {
        return;
      }
      let userData = this.userData;
      if (userData == null) {
        return;
      }

      let userName = this.userName.removeBlanks();
      if (userName.length == 0) {
        this.$toast('请输入账户名称！');
        return;
      }

      let pwd = this.pwd.removeBlanks();
      if (pwd.length == 0) {
        this.$toast('请输入密码！');
        return;
      }

      let mobile = this.mobile.removeBlanks();
      if (mobile.length == 0) {
        this.$toast('请输入手机号！');
        return;
      }

      if (!mobile.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let verifyCode = this.verifyCode.removeBlanks();
      if (verifyCode.length == 0) {
        this.$toast('请输入验证码！');
        return;
      }

      let params = {
        mobile: mobile,
        vxUnionid: userData.wxUserInfoModel.unionid,
        vx: userData.wxUserInfoModel.nickname,
        nickname: userName,
        verificationCode: verifyCode,
        password: pwd,
      };

      this.requestLoading = true;
      let _this = this;
      this.httpManager.ajax.userBind(params, function (data) {
        _this.requestLoading = false;

        let code = data.code;
        if (code == 0) {
          _this.$toast('绑定成功！');
          _this.dealWithRegisterSuccess(data.data);
        } else if (code == 1) {
          _this.$toast('输入信息有误！');
        } else if (code == 2) {
          _this.$toast('验证码错误！');
        } else if (code == 3) {
          _this.$toast('账号或密码不正确！');
        } else {
          _this.$toast('绑定失败');
        }
      }, function (data) {
        _this.requestLoading = false;
        _this.$toast('请求失败，请重试！');
      })
    },

    skipButtonClicked() {
      if (this.requestLoading) {
        return;
      }
      let userData = this.userData;
      let params = {
        isTeam: 0,
        vxUnionid: userData.wxUserInfoModel.unionid,
        name: userData.wxUserInfoModel.nickname,
        headPortrait: userData.wxUserInfoModel.headimgurl,
        sex: userData.wxUserInfoModel.sex,
        vx: userData.wxUserInfoModel.nickname
      };

      let _this = this;
      this.requestLoading = true;
      this.httpManager.ajax.userLogon(params, function (data) {
        _this.requestLoading = false;
        let code = data.code;
        if (code == 0) {
          _this.dealWithRegisterSuccess(data.data);
          return;
        }
        _this.$toast('请求失败！');
      }, function () {
        _this.requestLoading = false;
        _this.$toast('请求失败，请重试！');
      })
    },

    dealWithRegisterSuccess(data) {
      this.dataManager.setWeixinData(null);
      this.userData = null;
      let user = data;
      let isTeam = user.isTeam;
      let token = user.token;
      let nickName = user.nickname;
      let saveUser = {
        token: token,
        isTeam: isTeam,
        nickName: nickName,
        userId: user.id
      };
      let dataManager = this.$store.state.dataStore;
      dataManager.setUser(saveUser);

      let rediretUrl = dataManager.getRedirectUrl();
      if (rediretUrl != null) {
        dataManager.setRedirectUrl(null);
        window.location.href = rediretUrl;
        return;
      }

      if (isTeam == 1) {
        this.$router.push({
          name: 'groupPage'
        });
      } else {
        this.$router.push({
          name: 'personalPage'
        });
      }


      // let personCenter = this.$router.resolve({
      //   name: 'personalPage'
      // });
      // window.location.href = personCenter.href;
    }
  }
}
</script>

<style scoped>
  #wx_bind_outer {
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
  }

  #wx_bind_outer > div {
    width: 100%;
    border: solid 1px #fc1a34;
    padding: 30px 15px;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    flex-wrap: nowrap;
    min-height: 60vh;
  }

  #wx_bind_outer .el-input /deep/ .el-input__inner:focus {
    border: solid 1px #fc1a34;
  }

  #wx_bind_outer #phone_input > .el-button {
    width: 150px;
    font-size: 0.8rem;
    padding-left: 0;
    padding-right: 0;
    margin-left: 3%;
    border: none;
    color: white;
    background-color: #fc1a34;
  }

  #wx_bind_outer #phone_input > .el-button:disabled {
    color: #eee;
    background-color: #FC7371;
  }

  @media screen and (min-width: 768px) {
    #wx_bind_outer #phone_input > .el-button {
      width: 200px;
      font-size: 1rem;
      margin-left: 5%

    }
  }



</style>



// WEBPACK FOOTER //
// src/pages/WeixinLoginBind.vue